export const quotationStatus = (status) => {
    if (status === 'refused') return 'label-danger'
    if (status === 'approved') return 'label-default'
    if (status === 'sent') return 'label-success'
    if (status === 'new') return 'label-warning'
}

export const dealPerceptionColor = (perception) => {
    if (perception === 'cold') return 'btn-primary'
    if (perception === 'warm') return 'btn-warning'
    if (perception === 'hot') return 'btn-danger'
    if (perception === 'no_perception') return 'btn-white'
}



// WEBPACK FOOTER //
// ./src/utils/helpers/label-colorify.js